<template>
  <div class="md-example-child">
    <div class="field-title">Amount</div>

    <md-input-item
      v-bind="$attrs"
      title="Rp"
      :error="error"
      is-virtual-keyboard
      virtual-keyboard-vm="AmountKeyBoard"
      clearable
      v-on="$listeners"
    />

    <md-number-keyboard
      ref="AmountKeyBoard"
      type="professional"
      hide-dot
      :ok-text="$t('confirm')"
    />
  </div>
</template>

<script>
import { InputItem, NumberKeyboard, Field, Icon } from 'mand-mobile'

export default {
  name: 'FinancialNumberKeyboard',

  components: {
    [InputItem.name]: InputItem,
    [NumberKeyboard.name]: NumberKeyboard,
    [Field.name]: Field,
    [Icon.name]: Icon
  },

  props: {
    error: {
      type: String,
      default: ''
    }
  }
}

</script>

<style lang="scss" scoped>
.md-field {
  padding: 0;
}

.md-example-child {
  margin-top: 50px;
}

::v-deep .md-field-item.is-solid .md-field-item-title {
  width: 54px;
  font-size: 36px;
}

::v-deep .md-input-item-fake {
  font-size: 72px;
  font-weight: 700;
}

::v-deep .md-input-item-fake-placeholder {
  font-size: 36px !important;
}

.field-title {
  padding: 24px 0;
  font-size: 28px;
  font-weight: 400;
  color: #7f7f7f;
}
</style>
